module.exports = __webpack_public_path__ + "img/GoldenCup.0a711543.svg";